import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import type { UpdateNotificationSettingsRequest } from '@/lib/api/notification-settings-api'
import { useAuth } from '@/hooks/use-auth'
import { notificationSettingsApi } from '@/lib/api/notification-settings-api'
import { m } from '@/lib/paraglide/messages'

export const notificationSettingsKeys = {
    settings: () => ['notification-settings'] as const,
}

export function useNotificationSettings() {
    const { hasPermission, arePermissionsLoaded } = useAuth()
    return useQuery({
        queryKey: notificationSettingsKeys.settings(),
        queryFn: async () => {
            const res = await notificationSettingsApi.getSettings()
            return res.data ?? null
        },
        enabled: arePermissionsLoaded && hasPermission('settings.manage'),
    })
}

export function useUpdateNotificationSettings() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: (data: UpdateNotificationSettingsRequest) =>
            notificationSettingsApi.updateSettings(data),
        onSuccess: () => {
            void qc.invalidateQueries({
                queryKey: notificationSettingsKeys.settings(),
            })
            toast.success(m.common_save_success())
        },
        onError: () => toast.error(m.common_save_error()),
    })
}
